import { useReveal } from '../hooks/UseReveal';
import { useState, useEffect } from "react";

import SpecialText from '../fragments/SpecialText';
import Image from "../fragments/Image";
import SmartLink from '../fragments/SmartLink';

export default function WhoAreWe({ block }) {

    const [blockLoaded, setBlockLoaded] = useState(false);

    useEffect(() => {
        setBlockLoaded(true);
    }, []);

    const introRevealRef = useReveal({ once: true });
    const mediaRevealRef = useReveal({ once: true });
    const textRevealRef = useReveal({ once: true });

    const heading_maximum_width = block.heading_maximum_width ? block.heading_maximum_width + 'em' : '30em';

    return (
        <div id={block.section_id} className={`c-page__block c-page__block--who-are-we c-who-are-we`}>
            <div className={`l-grid l-bottom-space`}>
                <div className={`l-grid__col l-grid__col--l-10-12 c-transition-in`} ref={introRevealRef}>
                    <h1 className="c-who-are-we__heading c-heading c-heading--accent" style={{ maxWidth: heading_maximum_width }}>
                        <SpecialText text={block.heading || 'Who Are We?'} />
                    </h1>
                    {block.introduction && (
                        <p className="c-heading c-who-are-we__introduction l-bottom-space" style={{ maxWidth: heading_maximum_width }}>
                            <SpecialText text={block.introduction || ''} />
                        </p>
                    )}
                </div>
            </div>
            <div className={`l-grid`}>
                <div className={`l-grid__col l-grid__col--m-5-12 l-grid__col--l-4-12 c-transition-in`} ref={mediaRevealRef}>
                    {block.img_src && (
                        <div className="c-parallax" data-speed="0.05">
                            <Image src={block.img_src} alt={block.img_alt || 'Who Are We Image'} className="c-who-are-we__image" width={block.img_width} height={block.img_height} />
                        </div>
                    )}
                </div>
                <div className={`l-grid__col l-grid__col--m-6-12 l-grid__col--m-push-1-12 l-grid__col--l-4-12 l-grid__col--l-push-4-12 l-top-space c-transition-in`} ref={textRevealRef}>
                    <div className="scope-text" dangerouslySetInnerHTML={{ __html: block.text || '' }} />
                    {block.button_text && block.button_url &&
                        <div className="c-links l-small-top-space">
                            <SmartLink 
                                link={block.button_url} 
                                className="c-links__link c-links__link--button"
                            >
                                <svg viewBox="0 0 22 10"><polygon points="16.93 .91 16.25 1.64 19.33 4.5 0 4.5 0 5.5 19.33 5.5 16.25 8.36 16.93 9.09 21.33 5 16.93 .91" /></svg>
                                {block.button_text}
                            </SmartLink>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
    
}